/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateMerchantAddressesRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateMerchantAddressesResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateMerchantAddresses = (request: UpdateMerchantAddressesRequest, options?: CashRequestOptions) => post<UpdateMerchantAddressesRequest, UpdateMerchantAddressesResponse>("/2.0/cash/update-merchant-addresses", request, {...options, rejectOnError: true })